import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl} from './Handler.js'
import store from '../store/index'

export function _getAll(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _create(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}
export function _update(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _getById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _delete(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants/${id}`;
    return axios.delete(url,config).then(_handleSuccess,_handleError)
}
export function _getConnections(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants/connection/getAll`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _getMyTenantInfo(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants/GetMyTenantInfo`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _updateTenantProfile(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants/tenantProfile`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _uploadFile(fileData){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'multipart/form-data' },};
    const url = `${_getUrl()}/tenants/tenantProfilePicture`;
    let formData = new FormData();
    formData.append('file', fileData);
    return axios.post(url,formData,config).catch(error => {
        console.log(error.response)
    }).then(_handleSuccess,_handleError)
} 
export function _getTenantPicture(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/tenants/tenantProfilePicture`;
    return axios.get(url,model,config).then(_handleSuccess,_handleError)
}